import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Fab } from "@mui/material";

import { ConversationsIcon } from "@/assets/icons";

import { StyledBadge } from "./styled";

type AccessChatButtonProps = {
    onClick: () => void;
    disabled?: boolean;
    numberOfUnreadMessages?: number;
};

const AccessChatButton: FC<AccessChatButtonProps> = ({ onClick, disabled = false, numberOfUnreadMessages }) => {
    const { t } = useTranslation();

    const fabStyle = {
        position: "fixed",
        bottom: 16,
        right: 16,
    };

    return (
        <Fab
            sx={fabStyle}
            style={{
                backgroundColor: "var(--color-tertiary)",
                opacity: disabled ? 0.7 : 1,
            }}
            aria-label={t("PageTitles.Conversations")}
            disabled={disabled}
            title={`${disabled ? t("Common.PreviewUserNotAllowed") : ""}`}
            onClick={onClick}
            data-testid="access_chat_button-button-chat"
        >
            {numberOfUnreadMessages ? (
                <StyledBadge
                    role="status"
                    aria-label={t("conversations.UnreadMessageCount", {
                        defaultValue_one: "1 unread messages",
                        defaultValue_other: "{{count}} unread messages",
                        count: numberOfUnreadMessages,
                    })}
                    badgeContent={numberOfUnreadMessages}
                    color="error"
                >
                    <ConversationsIcon />
                </StyledBadge>
            ) : (
                <ConversationsIcon />
            )}
        </Fab>
    );
};

export default AccessChatButton;
